
   let playPauseBtn = document.getElementById("playPause");
   let volumeSlider = document.getElementById("volume");
   let muteBtn = document.getElementById("mute");
   let fullscreenBtn = document.getElementById("fullscreen");
   let timeLabel = document.getElementById("time");
   let progressContainer = document.getElementById("progressContainer");

    progressContainer.addEventListener("click", seek);

    volumeSlider.addEventListener("input", updateVolume);
    muteBtn.addEventListener("click", toggleMute);

    fullscreenBtn.addEventListener("click", toggleFullscreen);

    // Keyboard shortcuts
    document.addEventListener("keydown", (e) => {
      if (e.target.tagName.toLowerCase() === "input") return;
      switch (e.key) {
        case " ":
        case "k":
          e.preventDefault();
          togglePlay();
          break;
        case "m":
          toggleMute();
          break;
        case "f":
          toggleFullscreen();
          break;
        case "ArrowRight":
          video.currentTime = Math.min(video.currentTime + 5, video.duration);
          break;
        case "ArrowLeft":
          video.currentTime = Math.max(video.currentTime - 5, 0);
          break;
      }
    });



    // Hide native controls
    video.controls = false;

    function formatTime(seconds) {
      if (isNaN(seconds)) return "0:00";
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60)
        .toString()
        .padStart(2, "0");
      return `${minutes}:${secs}`;
    }

    function updatePlayPauseIcon() {
      if (video.paused || video.ended) {
        playPauseIcon.textContent = "▶️";
      } else {
        playPauseIcon.textContent = "⏸️";
      }
    }

    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }


    function updateProgress() {
      const percent = (video.currentTime / video.duration) || 0;
      progress.style.width = `${percent * 100}%`;
      timeLabel.textContent = `${formatTime(video.currentTime)} / ${formatTime(video.duration)}`;
    }

    function seek(e) {
      const rect = progressContainer.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const percent = offsetX / rect.width;
      video.currentTime = percent * video.duration;
    }

    function updateVolume() {
      video.volume = volumeSlider.value;
      video.muted = video.volume === 0;
      muteIcon.textContent = video.muted ? "🔇" : "🔊";
    }

    function toggleMute() {
      video.muted = !video.muted;
      muteIcon.textContent = video.muted ? "🔇" : "🔊";
      volumeSlider.value = video.muted ? 0 : (video.volume || 1);
    }

    function toggleFullscreen() {
      if (!document.fullscreenElement) {
        if (video.requestFullscreen) video.requestFullscreen();
        else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen();
        else if (video.msRequestFullscreen) video.msRequestFullscreen();
      } else {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
        else if (document.msExitFullscreen) document.msExitFullscreen();
      }
    }

    // Event listeners
    playPauseBtn.addEventListener("click", togglePlay);
    video.addEventListener("click", togglePlay);

    video.addEventListener("play", updatePlayPauseIcon);
    video.addEventListener("pause", updatePlayPauseIcon);
    video.addEventListener("timeupdate", updateProgress);
    video.addEventListener("loadedmetadata", updateProgress);

    progressContainer.addEventListener("click", seek);

    volumeSlider.addEventListener("input", updateVolume);
    muteBtn.addEventListener("click", toggleMute);

    fullscreenBtn.addEventListener("click", toggleFullscreen);

   
 